import {useTranslation} from 'react-i18next'

export const useFormInputLabelWithSuffix = ({
  label,
  optional
}: {
  label: string
  optional?: boolean
}) => {
  const {t} = useTranslation()

  let suffix = ''
  if (optional) suffix = ` (${t('form.label.optional')})`

  return label + suffix
}
